export default from './NonPsychic';



// WEBPACK FOOTER //
// ./src/elements/non-psychic/index.jsx